import React, { useEffect, useState } from 'react';
import '../styling/UpdatesPage.css';
import { db } from '../firebaseConfig'; // Import your Firestore instance
import { collection, getDocs, query, orderBy } from "firebase/firestore";

function UpdatesPage() {
  const [updates, setUpdates] = useState([]);

  useEffect(() => {
    async function fetchUpdates() {
      try {
        const q = query(collection(db, "updates"), orderBy("date", "desc"));
        const querySnapshot = await getDocs(q);
        const updatesList = [];
        querySnapshot.forEach((doc) => {
          updatesList.push({ id: doc.id, ...doc.data() });
        });
        setUpdates(updatesList);
      } catch (error) {
        console.error("Error fetching updates:", error);
      }
    }
    fetchUpdates();
  }, []);

  return (
    <section className='updates-section'>
      <div className="updates-container container">
        <h3>Latest Updates</h3>
        <div className="updates-list">
          {updates.map((update) => (
            <div key={update.id} className="update-post">
              <h2>{update.title}</h2>
              <span className="update-date">{update.date}</span>
              <p>{update.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default UpdatesPage;
